import {
  Directive,
  effect,
  ElementRef,
  EventEmitter,
  inject,
  input,
  InputSignal,
  Output,
} from '@angular/core';

@Directive({
  selector: '[smoothSize]',
  standalone: true,
})
export class SmoothSizeDirective {
  public readonly smoothHeight: InputSignal<boolean> = input<boolean>(false);
  public readonly smoothWidth: InputSignal<boolean> = input<boolean>(false);
  public readonly duration: InputSignal<number> = input<number>(150);
  public readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  @Output() public readonly finishAnimation = new EventEmitter<'height' | 'width'>();

  private observerHeight: ResizeObserver;
  private observerWidth: ResizeObserver;

  private readonly observeSmoothHeight = effect(() => {
    const element = this.elementRef.nativeElement;
    if (!element) return;

    if (!this.observerHeight) this.observerHeight = this.getObserverSize('height');

    const smoothHeight = this.smoothHeight();
    if (smoothHeight) {
      this.observerHeight.observe(element);
      return;
    }
    this.observerHeight.unobserve(element);
  })

  private readonly observeSmoothWidth = effect(() => {
    const element = this.elementRef.nativeElement;
    if (!element) return;

    if (!this.observerWidth) this.observerWidth = this.getObserverSize('width');

    const smoothWidth = this.smoothWidth();
    if (smoothWidth) {
      this.observerWidth.observe(element);
      return;
    }
    this.observerWidth.unobserve(element);
  })

  private getObserverSize(size: 'height' | 'width'): ResizeObserver {
    const element = this.elementRef.nativeElement;
    let isAnimating = false;
    let lastSize: number;
    return new ResizeObserver(() => {

      const contentSize = element.getBoundingClientRect()[size];
      const elementInDOM = document.body.contains(element);
      const isVisible = element.checkVisibility();
      if (!elementInDOM || !isVisible || isAnimating || lastSize === contentSize || typeof contentSize !== 'number' || (typeof lastSize !== 'number' && !contentSize)) return;

      if (typeof lastSize === 'number') {
        isAnimating = true;

        element.animate([{ [size]: `${lastSize}px` }, { [size]: `${contentSize}px` }], {
          duration: this.duration(),
          easing: 'ease-in-out'
        }).onfinish = () => {
          isAnimating = false;
          lastSize = contentSize;
          this.finishAnimation.emit(size);
        };

        return;
      }

      lastSize = contentSize;
    });
  }
}
